// Rimosso perché non utilizzato al momento
// import { usePostJwtLogout } from '@framework/api-client';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AuthActions, useAuth } from '../../state/AuthSlice.tsx';
import { AuthSubject } from '../../state/AuthSubject.tsx';
import { useSetLogoutHistoryState } from './useSetLogoutHistoryState.ts';

interface UseLogoutOptions {
  onLogout?: () => void;
}

export function useLogout(options?: UseLogoutOptions) {
  const { onLogout } = options ?? {};

  const auth = useAuth();
  const dispatch = useDispatch();
  const setLogoutHistoryState = useSetLogoutHistoryState();
  // const { mutateAsync: runLogout } = usePostJwtLogout();
  const [isLoading, setIsLoading] = useState(false);

  if (!auth.isLogged && !auth.isPrelogged) return {};

  return {
    isLoading,
    logout: async () => {
      setIsLoading(true);

      // try {
      //   // await runLogout();
      // } catch (e) {
      //   // Non blocca il logout in caso di errore
      //   console.error('Errore nella procedura di logout', e);
      // }

      dispatch(AuthActions.logout());
      AuthSubject.next({ type: 'logout', auth });
      onLogout?.();
      setIsLoading(false);
      setLogoutHistoryState();
      if (auth.logoutUrls && auth.logoutUrls.length > 0) {
        window.location.href = auth.logoutUrls[0];
      }
    },
  };
}
